import { Button, Input } from "antd";
import { DeleteIcon, TickIcon } from "../../../../../atoms/CustomIcons";

interface PropsType {
  item: {
    id: string;
    name: string;
    color?: string;
  };
  createTag: (
    moduleName: string,
    tagName: string,
    colorName: string,
    id?: string
  ) => void;
  moduleName: string;
  changeColor?: boolean;
  deleteTag: (id: string) => void;
}

export default function TagPopOver(props: PropsType) {
  const { item, createTag, moduleName, changeColor, deleteTag } = props;

  return (
    <div className="popover_content">
      <div className="popover_input">
        <Input
          defaultValue={item?.name}
          onChange={(e) => e.stopPropagation()}
          onBlur={(e) =>
            e?.target?.value !== item?.name
              ? createTag(
                  moduleName,
                  e?.target?.value,
                  item?.color ?? "default_tag",
                  item?.id
                )
              : null
          }
        />
      </div>

      <div className="pop_delete">
        <Button
          type="text"
          icon={<DeleteIcon />}
          onClick={() => {
            deleteTag(item?.id);
          }}
        >
          Delete
        </Button>
      </div>

      {changeColor && (
        <>
          <h5>Change color to</h5>
          <ul>
            <li>
              <Button
                type="text"
                className="color_popover"
                onClick={() =>
                  createTag(moduleName, item?.name, "grey_tag", item?.id)
                }
              >
                <span
                  className="badge"
                  style={{ border: "1px solid #98A3A9", background: "#DEE5E6" }}
                />{" "}
                Grey
                {item?.color === "grey_tag" && (
                  <TickIcon style={{ color: "#00A07D", marginLeft: "auto" }} />
                )}
              </Button>
            </li>

            <li>
              <Button
                type="text"
                className="color_popover"
                onClick={() =>
                  createTag(moduleName, item?.name, "violet_tag", item?.id)
                }
              >
                <span
                  className="badge"
                  style={{ border: "1px solid #6454F4", background: "#E7EAFF" }}
                />{" "}
                Violet
                {item?.color === "violet_tag" && (
                  <TickIcon style={{ color: "#00A07D", marginLeft: "auto" }} />
                )}
              </Button>
            </li>
            <li>
              <Button
                type="text"
                className="color_popover"
                onClick={() =>
                  createTag(moduleName, item?.name, "red_tag", item?.id)
                }
              >
                <span
                  className="badge"
                  style={{ border: "1px solid #D33D3D", background: "#FEE8E8" }}
                />{" "}
                Red
                {item?.color === "red_tag" && (
                  <TickIcon style={{ color: "#00A07D", marginLeft: "auto" }} />
                )}
              </Button>
            </li>
            <li>
              <Button
                type="text"
                className="color_popover"
                onClick={() =>
                  createTag(moduleName, item?.name, "orange_tag", item?.id)
                }
              >
                <span
                  className="badge"
                  style={{ border: "1px solid #F06400", background: "#FDEBDE" }}
                />{" "}
                Orange
                {item?.color === "orange_tag" && (
                  <TickIcon style={{ color: "#00A07D", marginLeft: "auto" }} />
                )}
              </Button>
            </li>
            <li>
              <Button
                type="text"
                className="color_popover"
                onClick={() =>
                  createTag(moduleName, item?.name, "yellow_tag", item?.id)
                }
              >
                <span
                  className="badge"
                  style={{ border: "1px solid #D2BE4F", background: "#FFF9D9" }}
                />{" "}
                Yellow
                {item?.color === "yellow_tag" && (
                  <TickIcon style={{ color: "#00A07D", marginLeft: "auto" }} />
                )}
              </Button>
            </li>
            <li>
              <Button
                type="text"
                className="color_popover"
                onClick={() =>
                  createTag(moduleName, item?.name, "green_tag", item?.id)
                }
              >
                <span
                  className="badge"
                  style={{ border: "1px solid #00A07D", background: "#E7F9F3" }}
                />{" "}
                Green
                {item?.color === "green_tag" && (
                  <TickIcon style={{ color: "#00A07D", marginLeft: "auto" }} />
                )}
              </Button>
            </li>
            <li>
              <Button
                type="text"
                className="color_popover"
                onClick={() =>
                  createTag(moduleName, item?.name, "blue_tag", item?.id)
                }
              >
                <span
                  className="badge"
                  style={{ border: "1px solid #44A6F1", background: "#D3E8FC" }}
                />{" "}
                Blue
                {item?.color === "blue_tag" && (
                  <TickIcon style={{ color: "#00A07D", marginLeft: "auto" }} />
                )}
              </Button>
            </li>
            <li>
              <Button
                type="text"
                className="color_popover"
                onClick={() =>
                  createTag(moduleName, item?.name, "purple_tag", item?.id)
                }
              >
                <span
                  className="badge"
                  style={{ border: "1px solid #943AF5", background: "#F6EAFF" }}
                />{" "}
                Purple
                {item?.color === "purple_tag" && (
                  <TickIcon style={{ color: "#00A07D", marginLeft: "auto" }} />
                )}
              </Button>
            </li>
          </ul>
        </>
      )}
    </div>
  );
}
